import { IVerifyOtpApiPayload, TSendOtpApiPayload } from '../../Models/LoginModal'
import { CONSTANTS } from '../Constant'

export const REPORT_COMPARISON = {
  GET_MIGRATION: (data: any) =>
    ({
      url: `${CONSTANTS.MIGRATION_URL}/update_content?content_id=${data?.contentId}&house_id=${data?.blitzHouseId}`,
      method: 'get',
      withoutBaseURL: true,
      headers: { Authorization: CONSTANTS.MIGRATION_TOKEN },
    }) as any,
}

export const GLOBAL_SEARCH = {
  POLL_EXPORT_STATUS: (exportId: string) =>
    ({
      url: `/global-search/export/action/list?${exportId}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const REPORTS_CRUD = {
  PUBLISHING_MONITORING: (data: any) =>
    ({
      url: '/contentReport/publishing-report-stats',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: data,
    }) as any,
}

/**
 * New API Configurations
 */

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

const HTTP_METHOD: Record<HttpMethod, HttpMethod> = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
}

interface ApiConfig {
  url: string
  method: HttpMethod
}

interface ApiKeys {
  USER: { GET_LIST: ApiConfig; GET_DETAIL: ApiConfig; CREATE: ApiConfig; UPDATE: ApiConfig }
  USER_CONFIG: { GET: ApiConfig; UPDATE: ApiConfig }
  ASSET_TYPE_DEFINITION: {
    LIST_ASSET_TYPE: ApiConfig
    VIEW_ASSET_TYPE: ApiConfig
    ADD_ASSET_TYPE_DEFINITION: ApiConfig
    UPDATE_ASSET_TYPE_DEFINITION: ApiConfig
    UPDATE_ASSET_TYPE_DEFINITION_STATUS: ApiConfig
    VIEW_ASSET_TYPE_BY_ASSET_TYPE: ApiConfig
    DOWNLOAD_ASSET_TYPE: ApiConfig
  }
  AUDIT_LOGS: { LIST_USER_ROLE_LOG: ApiConfig; EXPORT_AUDIT_TRAILS: ApiConfig }
  ROLES: {
    VIEW_ROLE: ApiConfig
    CREATE_ROLE: ApiConfig
    LIST_ROLE: ApiConfig
    EDIT_ROLE: ApiConfig
    DELETE_ROLE: ApiConfig
    CHANGE_STATUS: ApiConfig
  }
  PERMISSION_ROLE: { GET: ApiConfig; APP_CONFIG: ApiConfig }
  SYSTEM_CONFIGURATION: {
    GET_MASTERS: ApiConfig
    MASTER_LIST: ApiConfig
    CREATE_MASTER: ApiConfig
    CREATE_UPDATE: ApiConfig
    CONFIG_LIST: ApiConfig
  }
  TOOLTIPS: { GET: ApiConfig; UPDATE: ApiConfig; DETAIL_BY_ID: ApiConfig }
  MANAGE_FILE: {
    ADD: ApiConfig
    LIST: ApiConfig
    GET: ApiConfig
    UPDATE: ApiConfig
    PRESIGNED: ApiConfig
    CONFIG: ApiConfig
  }
  PINNED_SEARCH: { LIST: ApiConfig; COUNT: ApiConfig }
  AUTH: { LOGIN: ApiConfig; REFRESH_TOKEN: ApiConfig; LOGOUT: ApiConfig }
  VIDEO_CONTENT_TYPE: {
    CREATE_ASSET_GROUP: ApiConfig
    UPDATE_ASSET_GROUP: ApiConfig
    UPDATE_LIVE_ASSET_GROUP: ApiConfig
    LIST_ASSET_GROUPS: ApiConfig
    VALIDATE_ASSET_GROUP: ApiConfig
    LINK_ASSET_GROUP: ApiConfig
    PREVIEW_URL: ApiConfig
    TRANSACTION_INPUT_DETAILS: ApiConfig
    LINKED_ASSETS: ApiConfig
    LIVE_ASSET_GROUP_ATTRIBUTES: ApiConfig
    VALIDATE_LIVE_ASSET_GROUP: ApiConfig
    PRESIGNED_URL_CSV: ApiConfig
    TEMPLATES_LIVE: ApiConfig
    TEMPLATES_RE_TRANSCODING: ApiConfig
    PREMARKDONE_LIVE: ApiConfig
    SEARCH_MEDIA: ApiConfig
    SEARCH_MEDIA_V2: ApiConfig
    SEARCH_SUBTITLE: ApiConfig
    PRESIGNED_URL_SUBTITLE: ApiConfig
    INITIATE_PREVIEW: ApiConfig
    DETAIL_ASSET_GROUP: ApiConfig
    INITIATE_TRANSCODE: ApiConfig
    GET_MEDIA_INFO_ASSETGROUPID: ApiConfig
    GET_PLATFORM_DETAILS: ApiConfig
    UPDATE_MEDIA_INFO: ApiConfig
    LATEST_ASSET_GROUP_STATUS: ApiConfig
    ADD_MEDIA_INFO: ApiConfig
    ADD_PLATFORM_DATA: ApiConfig
    FETCH_FROM_VE: ApiConfig
    UNLINK_ASSET_GROUP: ApiConfig
    GET_MEDIA_INFO: ApiConfig
    REFETCH_MEDIA_INFO_VE: ApiConfig
    DELETE_MEDIA_INFO: ApiConfig
    MIGRATE_DETAILS_VE_: ApiConfig
    GET_ASSET_GROUP_DETAILS: ApiConfig
    CANCEL_TRANSCODING: ApiConfig
    GENERATE_URL_LIVE: ApiConfig
  }
  HOMEPAGE_ROUTE: {
    COMPARISON_LIST: ApiConfig
    RECENT_ACTIVITY: ApiConfig
    UPLOAD_SUBTITLE: ApiConfig
    GET_SUBTITLE_DATA: ApiConfig
    LIST_SUBTITLE: ApiConfig
    SUBTITLE_PRESIGNED_URL: ApiConfig
  }
  DASHBOARD_API: {
    GET_HOME_PAGE: ApiConfig
    GET_INJUSTION_REPORT: ApiConfig
    REPORTS_GET_BY_ID: ApiConfig
  }
  ATTRIBUTE_REPOSITORY: {
    LIST_ATTRIBUTE_REPO: ApiConfig
    VIEW_ATTRIBUTE_REPO: ApiConfig
    CREATE_ATTRIBUTES: ApiConfig
    UPDATE_ATTRIBUTES: ApiConfig
    CHANGE_STATUS: ApiConfig
    DELETE_ATTRIBUTE: ApiConfig
    GET_ASSET_VALIDATION_LIST: ApiConfig
  }
  GEO_POLICY: {
    LIST_GEO_POLICY: ApiConfig
    VIEW_GEO_POLICY_REPO: ApiConfig
    CREATE_POLICY: ApiConfig
    EDIT_POLICY: ApiConfig
    CHANGE_STATUS: ApiConfig
    DELETE_GEO_POLICY: ApiConfig
  }
  AD_BREAK_POLICY: {
    CREATE_AD_BREAK_POLICY: ApiConfig
    LIST_AD_BREAK_POLICY: ApiConfig
    GET_AD_BREAK_POLICY: ApiConfig
    UPDATE_AD_BREAK_POLICY: ApiConfig
    DELETE_AD_BREAK_POLICY: ApiConfig
  }
  SPORTS_GEO_POLICY: { LIST_SPORTS_GEO_POLICIS: ApiConfig }
  MASTER_APIS: {
    META_CATEGORIES: ApiConfig
    LIST_DATA_SOURCE: ApiConfig
    LIST_MASTERS_FETCH_ALL: ApiConfig
    GET_COUNTRY: ApiConfig
    GET_MASTER_LIST: ApiConfig
    DEFAULT_LIST: ApiConfig
    ADD_SYSTEM_CONFIG: ApiConfig
  }
  PARTNER_APIS: {
    GET_ALL_PARTNERS: ApiConfig
    VIEW_PARTNER: ApiConfig
    RETRIGGER: ApiConfig
    EDIT_PARTNER: ApiConfig
    CREATE_PARTNER: ApiConfig
  }
  IMAGE_APIS: {
    PRESIGNED_URL: ApiConfig
    DELETE_VARIANT: ApiConfig
    UPDATE_VARIANT: ApiConfig
    GET_DETAILS: ApiConfig
    GET_PREFIX_DETAILS: ApiConfig
    GET_S3_IMAGES_LIST: ApiConfig
    BULK_PRESIGNED_URL: ApiConfig
    BULK_IMAGE_UPLOAD: ApiConfig
    CREATE_IMAGE_VARIANT: ApiConfig
  }
  GLOBAL_SEARCH: {
    SEARCH: ApiConfig
    ATTRIBUTE: ApiConfig
    ASSET_DEFINITION: ApiConfig
    EXPORT_ADD: ApiConfig
    EXPORT_LIST: ApiConfig
    NESTED_LIST: ApiConfig
  }
  ADVANCED_SEARCH: {
    SAVE_SEARCH: ApiConfig
    SAVE_SEARCH_LIST: ApiConfig
    DELETE_PINNED_SEARCH: ApiConfig
  }
  BULK_UPLOAD: {
    ADD_JOB: ApiConfig
    GET_JOB_LIST: ApiConfig
    GET_JOB_DETAILS: ApiConfig
    UPDATE_JOB: ApiConfig
  }
  BULK_UPDATE: {
    CANCEL_JOB: ApiConfig
    DOWNLOAD_JOB_CSV: ApiConfig
    PRESIGNED_URL_UPLOAD_CSV: ApiConfig
    DOWNLOD_CSV_DOWNLOAD: ApiConfig
    GET_TEMPLATE: ApiConfig
  }
  CONTENT: {
    CREATE: ApiConfig
    GET_DETAIL: ApiConfig
    GET_APPLICABLE_POLICIES: ApiConfig
    VIEW_MARK_DONE_STATUS: ApiConfig
    GET_OTHER_VERSIONS: ApiConfig
    CREATE_ASSET: ApiConfig
    DELETE_ASSET: ApiConfig
    CLONE_ASSET: ApiConfig
    MARK_DONE: ApiConfig
    PUBLISH_CONTENT: ApiConfig
    SCHEDULE_CREATE: ApiConfig
    SCHEDULE_UPDATE: ApiConfig
    SCHEDULE_DELETE: ApiConfig
    SCHEDULE_LIST: ApiConfig
    DEPUBLISH_CONTENT: ApiConfig
    DEPENDENT_CONTENT_LIST: ApiConfig
    VALIDATE_DRAFT_EXISTS: ApiConfig
    CREATE_OVERIDE_VERSION: ApiConfig
    CONTENT_DOWNLOAD: ApiConfig
    AUDIT_TRAILS_ARCHIVED_LOGS: ApiConfig
    REPUBLISH_CONTENT: ApiConfig
    VALIDATE_IDS: ApiConfig
    NESTED_VERSION_LIST: ApiConfig
    MARK_DONE_BATCH: ApiConfig
    MARK_DONE_VARIANT: ApiConfig
  }
  EMAIL_REPORT: { EXPORT_REPORT_LIST: ApiConfig }
  BULK_STATE_CHANGE: { ADD_JOB: ApiConfig; UPDATE_JOB: ApiConfig; GET_REPORT_LIST: ApiConfig }
  NOTIFICATIONS: {
    GET: ApiConfig
    MARK_AS_READ: ApiConfig
    GET_NON_DELIVERED_NOTIFICATIONS: ApiConfig
  }
  BULK_APIS: {
    GET_ALL_TRANSCODING: ApiConfig
    ADD_TRANSCODING_JOB: ApiConfig
    TRANSCODING_JOB_UPDATE: ApiConfig
    TRANSCODING_JOB_VIEW: ApiConfig
    DOWNLOAD_JOB_REPORT: ApiConfig
    CANCEL_JOB: ApiConfig
    RERUN_BULK_UPLOAD: ApiConfig
    RERUN_BULK_STATE: ApiConfig
    RERUN_BULK_INTERACTIVE: ApiConfig
    RERUN_BULK_TRANSCODE: ApiConfig
  }
  ASSET_CURD_LINKING: {
    GET_DATA_BASED_ON_ID: any
    GET_DATA_BASED_ON_CONTENT_ID: any
    GET_LINKED_REF_DATA_BASED_ON_ID: any
  }
  REPORTS: {
    GET_INGESTION_REPORT: ApiConfig
    EXPORT_CONTENT_INGESTION_REPORT: ApiConfig
    GET_BULK_OPERATIONS_REPORT: ApiConfig
    GET_PUBLISHING_MONITORING_REPORT: ApiConfig
    GET_SNP_REVIEW_REPORT: ApiConfig
    EXPORT_SNP_REVIEW_REPORT: ApiConfig
    GET_SNP_REVIEW_REPORT_BY_ID: ApiConfig
    ACCEPT_SNP_REVIEW: ApiConfig
    GET_PRESIGNED_STREAMING_URL: ApiConfig
  }
  PRESIGNED_URL_V2: {
    GET_PRESIGNED_URL: ApiConfig
  }
}

export const API_LIST: ApiKeys = {
  // user start
  USER: {
    GET_LIST: { url: '/v1/users', method: HTTP_METHOD.GET },
    GET_DETAIL: {
      url: '/v1/users?page=1&filterBy=_id&filterValue=:userId&filterCondition=isEqualTo',
      method: HTTP_METHOD.GET,
    },
    CREATE: { url: '/v1/users', method: HTTP_METHOD.POST },
    UPDATE: { url: '/v1/users/:userId', method: HTTP_METHOD.PUT },
  },
  // user end
  // user config start
  USER_CONFIG: {
    GET: { url: '/v1/users/configurations/:userId', method: HTTP_METHOD.GET },
    UPDATE: { url: '/v1/users/configurations/:userId', method: HTTP_METHOD.PATCH },
  },
  // user config end
  // roles start
  ROLES: {
    VIEW_ROLE: { url: '/v1/roles/:roleId', method: HTTP_METHOD.GET as HttpMethod },
    CREATE_ROLE: { url: '/v1/roles', method: HTTP_METHOD.POST as HttpMethod },
    LIST_ROLE: { url: '/v1/roles', method: HTTP_METHOD.GET as HttpMethod },
    EDIT_ROLE: { url: '/v1/roles/:roleId', method: HTTP_METHOD.PUT as HttpMethod },
    DELETE_ROLE: { url: '/v1/roles/:roleId', method: HTTP_METHOD.DELETE as HttpMethod },
    CHANGE_STATUS: { url: '/v1/roles/:roleId', method: HTTP_METHOD.PATCH as HttpMethod },
  },
  // roles end
  // permission start
  PERMISSION_ROLE: {
    GET: { url: '/v1/auth/permissions', method: HTTP_METHOD.GET as HttpMethod },
    APP_CONFIG: { url: '/v1/auth/app-config', method: HTTP_METHOD.GET as HttpMethod },
  },
  // permission end
  // system configuration start
  SYSTEM_CONFIGURATION: {
    GET_MASTERS: {
      url: '/v1/system-configurations/masters/systemConfigurations',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    MASTER_LIST: { url: '/v1/system-configurations', method: HTTP_METHOD.GET as HttpMethod },
    CREATE_MASTER: { url: '/v1/system-configurations', method: HTTP_METHOD.POST as HttpMethod },
    CREATE_UPDATE: {
      url: '/v1/system-configurations/:key',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    CONFIG_LIST: { url: '/v1/system-configurations', method: HTTP_METHOD.GET as HttpMethod },
  },
  // system configuration end
  // tooltip start
  TOOLTIPS: {
    GET: { url: '/v1/tooltips', method: HTTP_METHOD.GET },
    UPDATE: { url: '/v1/tooltips/:tooltipsId', method: HTTP_METHOD.PUT },
    DETAIL_BY_ID: { url: '/v1/tooltips/:tooltipsId', method: HTTP_METHOD.GET },
  },
  // tooltip end
  // manage file start
  MANAGE_FILE: {
    LIST: { url: '/v1/files-job/filter', method: HTTP_METHOD.POST as HttpMethod },
    ADD: { url: '/v1/files-job', method: HTTP_METHOD.POST as HttpMethod },
    GET: { url: '/v1/files-job/:jobId', method: HTTP_METHOD.GET as HttpMethod },
    UPDATE: { url: '/v1/files-job/:jobId', method: HTTP_METHOD.PATCH as HttpMethod },
    PRESIGNED: { url: '/v1/files/presigned-urls', method: HTTP_METHOD.POST as HttpMethod },
    CONFIG: { url: '/v1/files/configurations', method: HTTP_METHOD.GET as HttpMethod },
  },
  // manage file end
  // pinned search start
  PINNED_SEARCH: {
    LIST: { url: '/v1/pinned-assets', method: HTTP_METHOD.GET as HttpMethod },
    COUNT: { url: '/v1/pinned-assets/count', method: HTTP_METHOD.GET as HttpMethod },
  },
  AUDIT_LOGS: {
    LIST_USER_ROLE_LOG: { url: '/v1/audit-trails', method: HTTP_METHOD.POST as HttpMethod },
    EXPORT_AUDIT_TRAILS: {
      url: '/v1/audit-trails/download',
      method: HTTP_METHOD.GET as HttpMethod,
    },
  },
  ASSET_TYPE_DEFINITION: {
    LIST_ASSET_TYPE: { url: '/v1/asset-definitions', method: HTTP_METHOD.GET as HttpMethod },
    VIEW_ASSET_TYPE: {
      url: '/v1/asset-definitions/:assetDefinitionId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    ADD_ASSET_TYPE_DEFINITION: {
      url: '/v1/asset-definitions',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    UPDATE_ASSET_TYPE_DEFINITION: {
      url: '/v1/asset-definitions/:assetTypeId',
      method: HTTP_METHOD.PUT as HttpMethod,
    },
    UPDATE_ASSET_TYPE_DEFINITION_STATUS: {
      url: '/v1/asset-definitions/:assetTypeId',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    VIEW_ASSET_TYPE_BY_ASSET_TYPE: {
      url: '/v1/asset-definitions',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    DOWNLOAD_ASSET_TYPE: {
      url: '/v1/asset-definitions/download/:assetTypeId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
  },
  VIDEO_CONTENT_TYPE: {
    CREATE_ASSET_GROUP: { url: '/v1/asset-groups', method: HTTP_METHOD.POST as HttpMethod },
    UPDATE_ASSET_GROUP: {
      url: '/v1/asset-groups/:assetGroupId',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    UPDATE_LIVE_ASSET_GROUP: {
      url: '/v1/asset-groups/live/:assetGroupId',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    LIST_ASSET_GROUPS: { url: '/v1/asset-groups', method: HTTP_METHOD.GET as HttpMethod },
    VALIDATE_ASSET_GROUP: {
      url: '/v1/asset-groups/validate',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    LINK_ASSET_GROUP: {
      url: '/v1/asset-groups/migrate/link',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    PREVIEW_URL: { url: '/v1/asset-groups/preview-url', method: HTTP_METHOD.GET as HttpMethod },
    TRANSACTION_INPUT_DETAILS: {
      url: '/v1/videos/:contentId/details',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    LINKED_ASSETS: {
      url: '/v1/asset-groups/:assetGroupId/:contentVersionId/assets',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    LIVE_ASSET_GROUP_ATTRIBUTES: {
      url: '/v1/asset-groups/attributes/live',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    VALIDATE_LIVE_ASSET_GROUP: {
      url: '/v1/asset-groups/validate/live',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    PRESIGNED_URL_CSV: {
      url: '/v1/asset-groups/presigned-url/live',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    TEMPLATES_LIVE: {
      url: '/v1/asset-groups/template/live',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    TEMPLATES_RE_TRANSCODING: {
      url: '/v1/bulk-transcode-job/template',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    PREMARKDONE_LIVE: {
      url: '/v1/asset-groups/pre-markdone/live',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    SEARCH_MEDIA: { url: '/v1/videos/search', method: HTTP_METHOD.POST as HttpMethod },
    SEARCH_MEDIA_V2: { url: '/v2/videos/search', method: HTTP_METHOD.POST as HttpMethod },
    SEARCH_SUBTITLE: { url: '/v1/subtitle/search', method: HTTP_METHOD.POST as HttpMethod },
    PRESIGNED_URL_SUBTITLE: {
      url: '/v1/subtitle/presigned-url',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    INITIATE_PREVIEW: { url: '/v1/asset-groups/preview', method: HTTP_METHOD.POST as HttpMethod },
    DETAIL_ASSET_GROUP: {
      url: '/v1/videos/asset-group-detail/:contentVersionId/:assetGroupId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    INITIATE_TRANSCODE: {
      url: '/v1/asset-groups/transcode',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    GET_MEDIA_INFO_ASSETGROUPID: {
      url: '/v1/media-info/:contentVersionId/:assetGroupId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    GET_PLATFORM_DETAILS: {
      url: '/v1/media-info/platform-detail/:contentVersionId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    UPDATE_MEDIA_INFO: { url: '/v1/media-info', method: HTTP_METHOD.PUT as HttpMethod },
    LATEST_ASSET_GROUP_STATUS: {
      url: '/v1/videos/workflow-status',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    ADD_MEDIA_INFO: { url: '/v1/media-info', method: HTTP_METHOD.POST as HttpMethod },
    ADD_PLATFORM_DATA: { url: '/v1/media-info', method: HTTP_METHOD.PATCH as HttpMethod },
    FETCH_FROM_VE: {
      url: '/v1/asset-groups/:assetGroupId/sync',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    UNLINK_ASSET_GROUP: { url: '/v1/asset-groups/unlink', method: HTTP_METHOD.PATCH as HttpMethod },
    GET_MEDIA_INFO: {
      url: '/v1/media-info/migration-detail',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    REFETCH_MEDIA_INFO_VE: {
      url: '/v1/media-info/resync/:contentVersionId/:assetGroupId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    DELETE_MEDIA_INFO: {
      url: '/v1/media-info/:mediaInfoId/:platformVariantIndexId',
      method: HTTP_METHOD.DELETE as HttpMethod,
    },
    MIGRATE_DETAILS_VE_: {
      url: '/v1/asset-groups/migrate/:fileKey/:contentId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    GET_ASSET_GROUP_DETAILS: {
      url: '/v1/videos/by-asset-group/:assetGroupId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    CANCEL_TRANSCODING: {
      url: '/v1/asset-groups/cancel-transcoding',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    GENERATE_URL_LIVE: {
      url: '/v1/asset-groups/generate-url/live',
      method: HTTP_METHOD.POST as HttpMethod,
    },
  },
  // auth start
  AUTH: {
    LOGIN: { url: '/v1/auth/login', method: HTTP_METHOD.GET },
    REFRESH_TOKEN: { url: '/v1/auth/refreshToken', method: HTTP_METHOD.GET },
    LOGOUT: { url: '/v1/auth/logout', method: HTTP_METHOD.GET },
  },
  // auth end
  // attribute repository start
  ATTRIBUTE_REPOSITORY: {
    LIST_ATTRIBUTE_REPO: { url: '/v1/attributes', method: HTTP_METHOD.GET as HttpMethod },
    VIEW_ATTRIBUTE_REPO: {
      url: '/v1/attributes/:attributeId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    CREATE_ATTRIBUTES: { url: '/v1/attributes', method: HTTP_METHOD.POST as HttpMethod },
    UPDATE_ATTRIBUTES: {
      url: '/v1/attributes/:attributeId',
      method: HTTP_METHOD.PUT as HttpMethod,
    },
    CHANGE_STATUS: { url: '/v1/attributes/:attributeId', method: HTTP_METHOD.PATCH as HttpMethod },
    DELETE_ATTRIBUTE: {
      url: '/v1/attributes/:attributeId',
      method: HTTP_METHOD.DELETE as HttpMethod,
    },
    GET_ASSET_VALIDATION_LIST: {
      url: '/v1/custom-validations',
      method: HTTP_METHOD.GET as HttpMethod,
    },
  },
  // attribute repository end
  // geo policy start
  GEO_POLICY: {
    LIST_GEO_POLICY: { url: '/v1/geo-policies', method: HTTP_METHOD.GET as HttpMethod },
    VIEW_GEO_POLICY_REPO: {
      url: '/v1/geo-policies/:geoPolicyId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    CREATE_POLICY: { url: '/v1/geo-policies', method: HTTP_METHOD.POST as HttpMethod },
    EDIT_POLICY: { url: '/v1/geo-policies/:geoPolicyId', method: HTTP_METHOD.PUT as HttpMethod },
    CHANGE_STATUS: {
      url: '/v1/geo-policies/:geoPolicyId',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    DELETE_GEO_POLICY: {
      url: '/v1/geo-policies/:geoPolicyId',
      method: HTTP_METHOD.DELETE as HttpMethod,
    },
  },
  AD_BREAK_POLICY: {
    CREATE_AD_BREAK_POLICY: {
      url: '/v1/ad-break-policies',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    LIST_AD_BREAK_POLICY: { url: '/v1/ad-break-policies', method: HTTP_METHOD.GET as HttpMethod },
    GET_AD_BREAK_POLICY: {
      url: '/v1/ad-break-policies/:policyId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    UPDATE_AD_BREAK_POLICY: {
      url: '/v1/ad-break-policies/:policyId',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    DELETE_AD_BREAK_POLICY: {
      url: '/v1/ad-break-policies/:policyId',
      method: HTTP_METHOD.DELETE as HttpMethod,
    },
  },
  // geo policy end
  SPORTS_GEO_POLICY: {
    LIST_SPORTS_GEO_POLICIS: {
      url: '/v1/sports-geo-policies',
      method: HTTP_METHOD.GET as HttpMethod,
    },
  },
  // HOMEPAGE api
  HOMEPAGE_ROUTE: {
    COMPARISON_LIST: { url: '/v1/report/comparison', method: HTTP_METHOD.GET as HttpMethod },
    RECENT_ACTIVITY: { url: '/v1/home/recent-activities', method: HTTP_METHOD.GET as HttpMethod },
    UPLOAD_SUBTITLE: { url: '/v1/subtitle', method: HTTP_METHOD.POST as HttpMethod },
    GET_SUBTITLE_DATA: {
      url: '/v1/subtitle/:contentVersionId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    LIST_SUBTITLE: { url: '/v1/subtitle/search', method: HTTP_METHOD.POST as HttpMethod },
    SUBTITLE_PRESIGNED_URL: {
      url: '/v1/subtitle/presigned-url',
      method: HTTP_METHOD.GET as HttpMethod,
    },
  },
  // HOMEPAGE api end
  // DASHBOARD api
  DASHBOARD_API: {
    GET_HOME_PAGE: { url: '/v1/dashboard', method: HTTP_METHOD.GET as HttpMethod },
    GET_INJUSTION_REPORT: { url: '/v1/ingestion-requests', method: HTTP_METHOD.POST as HttpMethod },
    REPORTS_GET_BY_ID: { url: '/v1/ingestion-requests/:id', method: HTTP_METHOD.GET as HttpMethod },
  },
  // DASHBOARD api end
  // geo policy end
  // Master Apis
  MASTER_APIS: {
    META_CATEGORIES: { url: '/v1/meta-categories', method: HTTP_METHOD.GET as HttpMethod },
    LIST_DATA_SOURCE: { url: '/v1/data-source', method: HTTP_METHOD.GET as HttpMethod },
    LIST_MASTERS_FETCH_ALL: { url: '/v1/masters', method: HTTP_METHOD.POST as HttpMethod },
    GET_COUNTRY: {
      url: '/v1/system-configurations?keyName=COUNTRIES&limit=500&page=1',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    GET_MASTER_LIST: { url: '/v1/system-configurations', method: HTTP_METHOD.GET as HttpMethod },
    DEFAULT_LIST: {
      url: '/v1/system-configurations?keyName=DEFAULT_LIST&limit=500&page=1',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    ADD_SYSTEM_CONFIG: {
      url: '/v1/system-configurations/:type',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
  },
  // master end
  // partners start
  PARTNER_APIS: {
    GET_ALL_PARTNERS: { url: '/v1/partners', method: HTTP_METHOD.GET as HttpMethod },
    VIEW_PARTNER: { url: '/v1/partners/:partnerId', method: HTTP_METHOD.GET as HttpMethod },
    RETRIGGER: {
      url: '/v1/ingestion-requests/retrigger/:requestId',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    EDIT_PARTNER: { url: '/v1/partners/:partnerId', method: HTTP_METHOD.PATCH as HttpMethod },
    CREATE_PARTNER: { url: '/v1/partners', method: HTTP_METHOD.POST as HttpMethod },
  },
  // image start
  IMAGE_APIS: {
    PRESIGNED_URL: { url: '/v1/images/presigned-url', method: HTTP_METHOD.GET },
    BULK_PRESIGNED_URL: { url: '/v1/images/presigned-urls', method: HTTP_METHOD.POST },
    DELETE_VARIANT: {
      url: '/v1/images/:contentId/:attributeName/:variantId',
      method: HTTP_METHOD.DELETE,
    },
    UPDATE_VARIANT: { url: '/v1/content/:contentId/images', method: HTTP_METHOD.PATCH },
    GET_DETAILS: { url: '/v1/content/:contentId/images', method: HTTP_METHOD.GET },
    GET_PREFIX_DETAILS: { url: '/v1/images/prefix-attribute', method: HTTP_METHOD.GET },
    GET_S3_IMAGES_LIST: { url: '/v1/images/search', method: HTTP_METHOD.POST },
    BULK_IMAGE_UPLOAD: { url: '/v1/images/bulk-upload', method: HTTP_METHOD.POST },
    CREATE_IMAGE_VARIANT: { url: '/v1/content/:contentId/images', method: HTTP_METHOD.POST },
  },
  // image end
  // global search start
  GLOBAL_SEARCH: {
    SEARCH: { url: '/v1.1/global-search', method: HTTP_METHOD.POST },
    ATTRIBUTE: { url: '/v1/global-search/attributes', method: HTTP_METHOD.GET },
    ASSET_DEFINITION: { url: '/v1/global-search/asset-definitions', method: HTTP_METHOD.GET },
    EXPORT_ADD: { url: '/v1/global-search/export-data', method: HTTP_METHOD.POST },
    EXPORT_LIST: { url: '/v1/global-search/export-requests', method: HTTP_METHOD.GET },
    NESTED_LIST: { url: '/v1/global-search/nested', method: HTTP_METHOD.POST },
  },
  // global search end
  // bulk upload API start
  BULK_UPLOAD: {
    ADD_JOB: { url: '/v1/:jobType', method: HTTP_METHOD.POST as HttpMethod },
    GET_JOB_LIST: { url: '/v1/:jobType', method: HTTP_METHOD.POST as HttpMethod },
    GET_JOB_DETAILS: { url: '/v1/:jobType/:jobId', method: HTTP_METHOD.GET as HttpMethod },
    UPDATE_JOB: { url: '/v1/:jobType/:jobId', method: HTTP_METHOD.PUT as HttpMethod },
  },
  // bulk upload API end
  // bulk update API start
  BULK_UPDATE: {
    CANCEL_JOB: { url: '/v1/:jobType/cancel-job/:jobId', method: HTTP_METHOD.PATCH as HttpMethod },
    DOWNLOAD_JOB_CSV: {
      url: '/v1/:jobType/:jobId/download',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    PRESIGNED_URL_UPLOAD_CSV: {
      url: '/v1/:jobType/:jobId/presigned-url',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    DOWNLOD_CSV_DOWNLOAD: {
      url: '/v1/bulk-update/download',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    GET_TEMPLATE: { url: '/v1/asset-groups/template/live', method: HTTP_METHOD.GET },
  },
  ADVANCED_SEARCH: {
    SAVE_SEARCH: { url: '/v1/search', method: HTTP_METHOD.POST },
    SAVE_SEARCH_LIST: { url: '/v1/search', method: HTTP_METHOD.GET },
    DELETE_PINNED_SEARCH: { url: '/v1/search/:searchId', method: HTTP_METHOD.DELETE },
  },
  CONTENT: {
    CREATE: { url: '/v1/contents', method: HTTP_METHOD.POST },
    GET_DETAIL: {
      url: '/v1/contents/:contentId/meta-categories/:metaCategory',
      method: HTTP_METHOD.GET,
    },
    GET_APPLICABLE_POLICIES: {
      url: '/v1/applicable-policies',
      method: HTTP_METHOD.POST,
    },
    VIEW_MARK_DONE_STATUS: { url: '/v1/contents/:contentId/mark-done', method: HTTP_METHOD.GET },
    GET_OTHER_VERSIONS: { url: '/v1/contents/:contentId/versions', method: HTTP_METHOD.GET },
    CREATE_ASSET: { url: '/v1/contents/meta-category/:contentId', method: HTTP_METHOD.PATCH },
    DELETE_ASSET: { url: '/v1/contents/:contentId', method: HTTP_METHOD.DELETE },
    CLONE_ASSET: { url: '/v1/contents/clone', method: HTTP_METHOD.POST },
    MARK_DONE: {
      url: '/v1/contents/meta-category/mark-done/:contentId',
      method: HTTP_METHOD.PATCH,
    },
    PUBLISH_CONTENT: { url: '/v1/contents/publish', method: HTTP_METHOD.POST },
    SCHEDULE_CREATE: { url: '/v1/contents/schedule', method: HTTP_METHOD.POST },
    SCHEDULE_UPDATE: { url: '/v1/contents/schedule/:scheduleId', method: HTTP_METHOD.PATCH },
    SCHEDULE_DELETE: { url: '/v1/contents/schedule/:scheduleId', method: HTTP_METHOD.DELETE },
    SCHEDULE_LIST: { url: '/v1/contents/:contentId/schedules', method: HTTP_METHOD.GET },
    DEPUBLISH_CONTENT: { url: '/v1/contents/de-publish', method: HTTP_METHOD.POST },
    DEPENDENT_CONTENT_LIST: {
      url: '/v1/contents/dependent-assets/:contentId',
      method: HTTP_METHOD.GET,
    },
    VALIDATE_DRAFT_EXISTS: { url: '/v1/contents/editable/:contentId', method: HTTP_METHOD.GET },
    CREATE_OVERIDE_VERSION: { url: '/v1/contents/draft-version', method: HTTP_METHOD.POST },
    CONTENT_DOWNLOAD: { url: '/v1/contents/:contentId/presigned-url', method: HTTP_METHOD.GET },
    AUDIT_TRAILS_ARCHIVED_LOGS: {
      url: '/v1/contents/:contentId/archived',
      method: HTTP_METHOD.GET,
    },
    REPUBLISH_CONTENT: { url: '/v1/contents/re-publish', method: HTTP_METHOD.POST },
    VALIDATE_IDS: { url: '/v1/contents/check-assets', method: HTTP_METHOD.POST },
    NESTED_VERSION_LIST: { url: '/v1/content-versions', method: HTTP_METHOD.GET },
    MARK_DONE_BATCH: {
      url: '/v2/contents/meta-categories/mark-done/:contentId',
      method: HTTP_METHOD.POST,
    },
    MARK_DONE_VARIANT: {
      url: '/v1/contents/meta-categories/variant-mark-done',
      method: HTTP_METHOD.POST,
    },
  },
  EMAIL_REPORT: {
    EXPORT_REPORT_LIST: {
      url: '/v1/reports/email-report?type=BULK_OPERATION_REPORT',
      method: HTTP_METHOD.POST,
    },
  },
  BULK_STATE_CHANGE: {
    ADD_JOB: { url: '/v1/bulk-state-job', method: HTTP_METHOD.POST },
    UPDATE_JOB: { url: '/v1/bulk-state-job/:jobId', method: HTTP_METHOD.PUT },
    GET_REPORT_LIST: { url: '/v1/bulk-jobs', method: HTTP_METHOD.POST },
  },
  NOTIFICATIONS: {
    GET: { url: '/v1/notifications', method: HTTP_METHOD.POST },
    MARK_AS_READ: { url: '/v1/notifications/status', method: HTTP_METHOD.POST },
    GET_NON_DELIVERED_NOTIFICATIONS: { url: '/v1/notifications', method: HTTP_METHOD.GET },
  },
  BULK_APIS: {
    GET_ALL_TRANSCODING: { url: '/v1/bulk-transcode-jobs', method: HTTP_METHOD.POST as HttpMethod },
    ADD_TRANSCODING_JOB: { url: '/v1/bulk-transcode-job', method: HTTP_METHOD.POST as HttpMethod },
    TRANSCODING_JOB_UPDATE: {
      url: '/v1/bulk-transcode-job/:transcodingJobId',
      method: HTTP_METHOD.PUT as HttpMethod,
    },
    TRANSCODING_JOB_VIEW: {
      url: '/v1/bulk-transcode-job/:transcodingJobId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    DOWNLOAD_JOB_REPORT: {
      url: '/v1/bulk-state-change/:transcodingJobId/download',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    CANCEL_JOB: {
      url: '/v1/bulk-state-change/cancel-job/:transcodingJobId',
      method: HTTP_METHOD.PATCH as HttpMethod,
    },
    RERUN_BULK_UPLOAD: {
      url: '/v1/bulk-upload-job/retrigger/:jobId',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    RERUN_BULK_STATE: {
      url: '/v1/bulk-state-job/retrigger/:jobId',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    RERUN_BULK_INTERACTIVE: {
      url: '/v1/bulk-interactive-job/retrigger/:jobId',
      method: HTTP_METHOD.POST as HttpMethod,
    },
    RERUN_BULK_TRANSCODE: {
      url: '/v1/bulk-transcode-job/retrigger/:jobId',
      method: HTTP_METHOD.POST as HttpMethod,
    },
  },
  ASSET_CURD_LINKING: {
    GET_DATA_BASED_ON_ID: {
      url: '/v1/contents/link/:contentId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    GET_DATA_BASED_ON_CONTENT_ID: {
      url: '/v1/contents/link/:contentId?isContentId=true',
      method: HTTP_METHOD.GET as HttpMethod,
    },
    GET_LINKED_REF_DATA_BASED_ON_ID: {
      url: '/v1/contents/episode/:contentId',
      method: HTTP_METHOD.GET as HttpMethod,
    },
  },
  REPORTS: {
    GET_INGESTION_REPORT: { url: '/v1/ingestion-requests', method: HTTP_METHOD.POST },
    EXPORT_CONTENT_INGESTION_REPORT: {
      url: '/v1/reports/email-report?type=CONTENT_INGESTION_REPORT',
      method: HTTP_METHOD.POST,
    },
    GET_BULK_OPERATIONS_REPORT: { url: '/v1/bulk-jobs', method: HTTP_METHOD.POST },
    GET_PUBLISHING_MONITORING_REPORT: {
      url: '/v1/service/contentReport/publishing-report-stats',
      method: HTTP_METHOD.GET,
    },
    GET_SNP_REVIEW_REPORT: { url: '/v1/asset-review-jobs', method: HTTP_METHOD.POST },
    EXPORT_SNP_REVIEW_REPORT: {
      url: '/v1/reports/email-report?type=ASSET_REVIEW_REPORT',
      method: HTTP_METHOD.POST,
    },
    GET_SNP_REVIEW_REPORT_BY_ID: { url: '/v1/asset-review/:id', method: HTTP_METHOD.GET },
    ACCEPT_SNP_REVIEW: { url: '/v1/asset-review/:id', method: HTTP_METHOD.POST },
    GET_PRESIGNED_STREAMING_URL: {
      url: '/v1/asset-review/presigned-streaming-url?key=:key',
      method: HTTP_METHOD.GET,
    },
  },
  PRESIGNED_URL_V2: {
    GET_PRESIGNED_URL: { url: '/v1/presigned-url', method: HTTP_METHOD.GET },
  },
}

export const API_CONFIG = (
  api: ApiConfig,
  data?: Record<string, any> | null,
  params?: Record<string, string | number | undefined> | null,
  queryParams?: string | Record<string, string | number> | null,
  headers?: any,
): {
  isNewConfig: boolean
  url: string
  method: HttpMethod
  data?: Record<string, any> | null
  headers?: any
} => {
  let finalUrl = api.url

  // Replace URL params if provided
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      finalUrl = finalUrl.replace(`:${key}`, encodeURIComponent(String(value)))
    })
  }

  // Handle query parameters as a string or object
  if (queryParams) {
    if (typeof queryParams === 'string') {
      finalUrl += `?${queryParams}`
    } else if (typeof queryParams === 'object') {
      const queryString = Object.entries(queryParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join('&')
      finalUrl += `?${queryString}`
    }
  }

  return {
    isNewConfig: true,
    url: finalUrl,
    method: api.method,
    ...(data !== undefined && { data }), // ✅ Explicitly allows null while excluding undefined
    ...(headers !== undefined && { headers }),
  }
}

export const ENTITLEMENT_CONTROL_POLICY_CRUD = {
  GET_POLICY_LIST: (queryParams: string) => ({
    url: '/entitlement-policies' + '?' + queryParams,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'get',
    data: {},
  }),
  GET_POLICY_DETAILS: (policyId: string) => ({
    url: `/entitlement-policies/${policyId}`,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'get',
    data: {},
  }),
  CREATE_POLICY: (data: any) => ({
    url: '/entitlement-policies',
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'post',
    data: data,
  }),
  UPDATE_POLICY: (data: any, id?: any) => ({
    url: `/entitlement-policies/${id}?statusChange${
      ['ACTIVE', 'INACTIVE'].includes(data?.status) ? '=true' : '=false'
    }`,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'patch',
    data: data,
  }),
  DELETE_POLICY: (policyId: string) => ({
    url: `/entitlement-policies/${policyId}`,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'delete',
    data: {},
  }),
  VALIDATE_IDS: (data: any) => ({
    url: '/content/action/check-assets',
    // version: 'v1',
    // versionReplaceFrom: 'v1/service',
    method: 'post',
    data: data,
  }),
}

export const LANGUAGE_CONTROL_POLICY_CRUD = {
  CREATE_POLICY: (data: any) => ({
    url: '/language-control-policies',
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'post',
    data: data,
  }),
  UPDATE_POLICY: (data: any, id?: any) => ({
    url: `/language-control-policies/${id}?statusChange${
      ['ACTIVE', 'INACTIVE'].includes(data?.status) ? '=true' : '=false'
    }`,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'patch',
    data: data,
  }),
  GET_POLICY_DETAILS: (policyId: string) => ({
    url: `/language-control-policies/detail/${policyId}`,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'get',
    data: {},
  }),
  GET_LANGUAGE_POLICY_LIST: (queryParams: string) => ({
    url: '/language-control-policies' + '?' + queryParams,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'get',
    data: {},
  }),
  DELETE_POLICY: (policyId: string) => ({
    url: `/language-control-policies/${policyId}`,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
    method: 'delete',
    data: {},
  }),
}
export const LIVE_AUTOMATION = {
  GET_TEMPLATE: () => ({
    url: '/content/video/action/getLiveAutomationTemplate',
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  GET_MASTER_TEMPLATE: () => ({
    url: '/content/video/action/liveAutomationAttributes',
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  VALIDATE_ATTRIBUTES: (data: any, updatedAt: any) => ({
    url: '/content/video/action/validateLiveAssetAssetGroup',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
    headers: { 'x-last-updated-time': new Date(updatedAt).getTime() },
  }),
  GENERATE_URL: (data: any, updatedAt: any) => ({
    url: '/content/video/action/generateUrl',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
    headers: { 'x-last-updated-time': new Date(updatedAt).getTime() },
  }),
  CANCEL_TRANSCODING: (data: any, updatedAt: any) => ({
    url: '/content/video/action/cancelTranscoding',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
    headers: { 'x-last-updated-time': new Date(updatedAt).getTime() },
  }),
  UPLOAD_CSV_DATA: (data: any, updatedAt: any) => ({
    url: '/content/video/action/updateLiveAssetGroup',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data: data,
    headers: { 'x-last-updated-time': new Date(updatedAt).getTime() },
  }),
  PRESIGNED_CSV_UPLOAD: (data: any) => ({
    url: '/content/video/action/getPreSignedUrlForLiveAutomation' + `?key=${data.key}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
}

export const APP_NOTIFICATIONS = {
  GET_NON_DELIVERED_NOTIFICATIONS: (query: string) => ({
    url: `/content/event-notifications/action/poll${query}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  GET_ALL_NOTIFICATIONS: (data: any) => ({
    url: '/content/event-notifications/action/list',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
  }),
  MARK_AS_READ: (data: any) => ({
    url: '/content/event-notifications/action/update',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
  }),
}

export const LOGIN = {
  SEND_OTP: (email: TSendOtpApiPayload) => ({
    url: '/auth/generateOtp/' + encodeURIComponent(email),
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
    version: 'v1',
    versionReplaceFrom: 'v1/service',
  }),
  VERIFY_OTP: (data: IVerifyOtpApiPayload) => ({
    url: '/auth/verifyOtp',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
    version: 'v1',
    versionReplaceFrom: 'v1/service',
  }),
  SETTINGS: () => ({
    url: '/settings',
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
    version: 'v1',
    versionReplaceFrom: 'v1/service',
  }),
}
